"use client";
import { useRouter } from "next/navigation";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import LoadingComponent from "@/components/loadingComponent";
import useLoading from "@/utils/useLoading";
import { getAccessToken } from "@/utils/auth";
import { encrypt, decrypt } from "@/lib/aes";

const validationSchema = yup.object({
  username: yup.string().required("User name is required"),
  password: yup.string().required("Password is required"),
  client_id: yup.string().required("Client ID is required"),
});

type QRCodeDetails = {
  client_id: string;
  two_factor_secret_key: string;
  qr_code: string;
  two_factor_enabled: boolean;
};

type UserLoginDetails = {
  client_id: string;
  is_first_login: boolean;
  is_otp_login: boolean;
  last_login_date: Date;
};
const getTwoFactowAuthenticationData = async (
  token: string,
  request:string
): Promise<QRCodeDetails> => {
  // const token = await getAccessToken();
  
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_API_URL}/api/user_detail/v1/two_factor_authentication/Authenticated/get_secret_key`,
    {
      method: "POST",
      headers: {
        "Content-type": "application/json",
         Authorization: `Bearer ${token}`
      },
      body: request,
    }
  );
  const response = await res.json();
  return response.data;
};



const getUserLoginDetails = async (
  token: string,
  client_id:string
): Promise<UserLoginDetails> => {
  // const token = await getAccessToken();
  
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_API_URL}/api/user_detail/v1/user_detail/get_user_login_details?client_id=${client_id}`,
    {
      method: "GET",
      headers: {
        "Content-type": "application/json",
         Authorization: `Bearer ${token}`
      },
      // body: request,
    }
  );
  const response = await res.json();
  return response.data;
};


const Login = () => {
  const { isLoading, setIsLoading } = useLoading();
  const router = useRouter();
  // localStorage.removeItem("client_id");
  // localStorage.removeItem("serializedrequest");
  // localStorage.removeItem("accessToken");
  // localStorage.removeItem("refreshToken");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(validationSchema)}

);


  const handleLogin = handleSubmit(async (request) => {
    try {
      setIsLoading(true);
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_API_AUTH_URL}/api/auth/v1/token`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            
          },
          body: JSON.stringify(request)
           
        }
      );

      const res = await response.json();
      if (response.ok) {
        localStorage.setItem("serializedrequest", res.data.serialized_request);
        localStorage.setItem("client_id", request.client_id);
        request.client_id = encrypt(request.client_id);
        const QRdetails = await getTwoFactowAuthenticationData(
          res.data.token,
          JSON.stringify(request)
        );
// const UserLoginDetail = await getUserLoginDetails(
//   res.data.token,
//   request.client_id
// );
//         if(UserLoginDetail.is_otp_login==true){
//           router.push("/otpverification");
//         }
        if (QRdetails.two_factor_enabled == true) {
          localStorage.setItem("accessToken", res.data.token);
          router.push("/twofactorverification");
        } else {
          localStorage.setItem("accessToken", res.data.token);
          localStorage.setItem("refreshToken", res.data.refresh_token);
          localStorage.setItem(
            "refreshTokenExpiry",
            res.data.refresh_token_expiry
          );
          const res1 = await fetch(
            `${process.env.NEXT_PUBLIC_API_URL}/api/user_detail/v1/user_detail/get_detail_by_client_id?client_id=${request.client_id}`,
            {
              method: "GET",
              cache: "no-store",
              headers: {
                "Content-type": "application/json",
                Authorization: `Bearer ${res.data.token}`,
              },
            }
          );
          const data = await res1.json();
          localStorage.setItem("is_admin_user", data.data.is_admin_user);
          router.push("/dashboard");
        }
      } else {
        try{
        request.client_id = decrypt(request.client_id);

        }catch(e){
          
        }
        setIsLoading(false);
        toast.error(res.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    } finally {
      // setIsLoading(false);
    }
  });
  return (
    <>
      {
        isLoading ? (
          <LoadingComponent />
        ) : (
          <main className="h-screen bg-loginPattern bg-cover">
            <div className="h-screen bg-background-dark bg-opacity-75 flex justify-center items-center">
              <div className="w-4/5 xl:w-1/4 lg:w-1/3 rounded-md bg-white">
                <div className="w-125 rounded-full bg-background-light -mt-12 m-auto">
                  <img src="/img/logo.png" alt="logo" className="w-full p-5" />
                </div>
                <form onSubmit={handleLogin}>
                  <div className="px-10 pt-5 pb-10">
                    <h1 className="text-center text-xl font-semibold text-textColor-dark mb-2">
                      Login to your Account
                    </h1>
                    <p className="text-center text-textColor-light mb-5 text-sm">
                      Welcome back! Please enter your details
                    </p>
                    <div className="mb-4">
                      <label className="label-control">Client ID</label>
                      <input
                        id="client_id"
                        {...register("client_id")}
                        type="text"
                        className={
                          errors["client_id"]
                            ? "form-control border-red-600"
                            : "form-control"
                        }
                        placeholder="Enter your Client ID"
                      />
                      {errors["client_id"] ? (
                        <span className="text-sm text-red-600">
                          {errors["client_id"].message}
                        </span>
                      ) : null}
                    </div>
                    <div className="mb-4">
                      <label className="label-control">User Name</label>
                      <input
                        id="username"
                        {...register("username")}
                        type="text"
                        className={
                          errors["username"]
                            ? "form-control border-red-600"
                            : "form-control"
                        }
                        placeholder="Enter your Username"
                      />
                      {errors["username"] ? (
                        <span className="text-sm text-red-600">
                          {errors["username"].message}
                        </span>
                      ) : null}
                    </div>
                    <div className="mb-4">
                      <label className="label-control">Password</label>
                      <input
                        id="password"
                        {...register("password")}
                        type="password"
                        className={
                          errors["password"]
                            ? "form-control border-red-600"
                            : "form-control"
                        }
                        placeholder="Enter your Password"
                      />
                      {errors["password"] ? (
                        <span className="text-sm text-red-600">
                          {errors["password"].message}
                        </span>
                      ) : null}
                    </div>
                    <div className="mb-4">
                      <button type="submit" className="btn-primary">
                        Login
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </main>
        )
      }
    </>
  );
};

export default Login;
